import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from 'ddc-classnames-js';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const HighlightedAttributeItem = ({ title, icon, address, phone, id }) => {
	const { deviceType } = useSelector(state => state.requestData);
	const isMobile = deviceType === 'MOBILE';
	const overlayRef = useRef(null);
	const cleanTitle = window._.unescape(title);

	const handleMobileScroll = () => {
		overlayRef.current.hide();
	};

	useEffect(() => {
		if (isMobile) {
			window.addEventListener('touchmove', handleMobileScroll);
		}
	}, [isMobile]);

	const popoverMarkup = (
		<Popover id="location-popover">
			{address.firstLineAddress}, {address.city}, {address.state}{' '}
			{address.postalCode} |{' '}
			{isMobile ? (
				<a
					href={`tel:${phone}`}
					data-phone-ref="SALES"
					data-account-ref={id}
				>
					{phone}
				</a>
			) : (
				phone
			)}
		</Popover>
	);

	return (
		<OverlayTrigger
			placement="top"
			overlay={popoverMarkup}
			trigger={isMobile ? 'click' : ['hover', 'focus']}
			rootClose
			ref={overlayRef}
		>
			<button
				type="button"
				aria-label={`This vehicle is located at ${cleanTitle}`}
				className={setClassNames([
					'chip',
					'chip-default',
					'd-flex',
					'align-items-center',
					'mr-3',
					'mb-3'
				])}
			>
				<i
					className={setClassNames([
						'ddc-icon',
						`${icon}`,
						'ddc-icon-size-large',
						'pr-3',
						'pt-1'
					])}
				/>
				{cleanTitle}
			</button>
		</OverlayTrigger>
	);
};

HighlightedAttributeItem.propTypes = {
	title: PropTypes.string.isRequired,
	icon: PropTypes.string.isRequired,
	address: PropTypes.shape({
		firstLineAddress: PropTypes.string,
		city: PropTypes.string,
		state: PropTypes.string,
		postalCode: PropTypes.string
	}).isRequired,
	phone: PropTypes.string.isRequired,
	id: PropTypes.string.isRequired
};

export default HighlightedAttributeItem;
